import '@/app/styles/index.css';
import { showStartupError } from '@/app/config/startup-error';
import { loadRuntimeConfig } from '@/shared/config';

const start = async (): Promise<void> => {
  await loadRuntimeConfig(import.meta.env.BASE_URL);
  const { bootstrap } = await import('@/app/bootstrap');
  await bootstrap();
};

const retryStartup = (): void => {
  void start().catch(() => {
    const root = document.getElementById('root');
    if (root) {
      showStartupError(root, retryStartup);
    }
  });
};

retryStartup();
